module.exports = __webpack_public_path__ + "static/media/file-export.157c2555.svg";